import { FieldModel } from "../shared/model/field-model";

export function createCrossFieldHandlerForPrimaryField(
  fieldState: FieldModel,
  confirmFieldState: FieldModel,
  setState: (state: FieldModel) => void,
  setConfirmState: (setState: FieldModel) => void,
  fieldValidator: (value: string) => string[],
  crossFieldValidator: (value: string, confirmValue: string) => string[],
  useOnChangeIsTouched?: boolean
): [
  (event: React.ChangeEvent<HTMLInputElement>) => void,
  (event: React.FocusEvent<HTMLInputElement>) => void,
  () => void
] {
  const runValidator = () => {
    fieldState.messages = fieldValidator(fieldState.value);
  };
  const runConfirmValidator = () => {
    confirmFieldState.messages = fieldValidator(confirmFieldState.value);
  };
  const runAllValidators = () => {
    if (fieldState.isTouched) {
      runValidator();
    }
    if (confirmFieldState.isTouched) {
      runConfirmValidator();
    }
    if (fieldState.isTouched && confirmFieldState.isTouched) {
      confirmFieldState.messages = crossFieldValidator(fieldState.value, confirmFieldState.value);
      setConfirmState({ ...confirmFieldState });
    }
    setState({ ...fieldState });
  };
  const onChangeHandlerNoOnChangeIsTouched = (event: React.ChangeEvent<HTMLInputElement>) => {
    fieldState.value = event.currentTarget.value;
    runAllValidators();
  };
  const onChangeHandlerOnChangeIsTouched = (event: React.ChangeEvent<HTMLInputElement>) => {
    fieldState.value = event.currentTarget.value;
    fieldState.isTouched = true;
    runAllValidators();
  };
  const onBlurHandler = (event: React.FocusEvent<HTMLInputElement>) => {
    fieldState.value = event.currentTarget.value;
    fieldState.isTouched = true;
    runAllValidators();
  };
  const invokeValidation = () => {
    fieldState.isTouched = true;
    runAllValidators();
  };

  let onChangeHandler = onChangeHandlerNoOnChangeIsTouched;
  if (useOnChangeIsTouched) {
    onChangeHandler = onChangeHandlerOnChangeIsTouched;
  }

  // return functions so the can be used in components..
  return [onChangeHandler, onBlurHandler, invokeValidation];
}

export function createCrossFieldHandlerForConfirmField(
  fieldState: FieldModel,
  confirmFieldState: FieldModel,
  setConfirmState: (setState: FieldModel) => void,
  crossFieldValidator: (value: string, confirmValue: string) => string[]
): [
  (event: React.ChangeEvent<HTMLInputElement>) => void,
  (event: React.FocusEvent<HTMLInputElement>) => void,
  () => void
] {
  const runAllValidators = () => {
    if (fieldState.isTouched && confirmFieldState.isTouched) {
      confirmFieldState.messages = crossFieldValidator(fieldState.value, confirmFieldState.value);
    }
    setConfirmState({ ...confirmFieldState });
  };
  const onChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    confirmFieldState.value = event.currentTarget.value;
    runAllValidators();
  };
  const onBlurHandler = (event: React.FocusEvent<HTMLInputElement>) => {
    confirmFieldState.value = event.currentTarget.value;
    confirmFieldState.isTouched = true;
    runAllValidators();
  };
  const invokeValidation = () => {
    confirmFieldState.isTouched = true;
    runAllValidators();
  };
  // return functions so the can be used in components..
  return [onChangeHandler, onBlurHandler, invokeValidation];
}
